/**
 * Parse stored event time into 12-hour parts.
 */
export const parseTimeParts = (value) => {
  if (!value) {
    return { hour: '', minute: '', period: 'AM' };
  }
  const trimmed = String(value).trim();
  const match12 = trimmed.match(/^(\d{1,2}):(\d{2})\s*(AM|PM)$/i);
  if (match12) {
    return {
      hour: String(parseInt(match12[1], 10)),
      minute: match12[2],
      period: match12[3].toUpperCase()
    };
  }
  const match24 = trimmed.match(/^(\d{1,2}):(\d{2})$/);
  if (match24) {
    let hour24 = parseInt(match24[1], 10);
    const minute = match24[2];
    const period = hour24 >= 12 ? 'PM' : 'AM';
    const hour12 = hour24 % 12 || 12;
    return { hour: String(hour12), minute, period };
  }
  return { hour: '', minute: '', period: 'AM' };
};

/**
 * Build a 12-hour time string for storage/display (e.g. "2:30 PM").
 */
export const buildTimeString = (hour, minute, period) => {
  if (!hour && !minute) return '';
  const h = hour || '12';
  const m = (minute || '00').padStart(2, '0');
  const p = period || 'AM';
  return `${h}:${m} ${p}`;
};

/**
 * Normalize any stored time value to 12-hour AM/PM display.
 */
export const formatEventTimeDisplay = (timeStr) => {
  if (!timeStr) return '';
  const { hour, minute, period } = parseTimeParts(timeStr);
  if (!hour && !minute) return String(timeStr).trim();
  return buildTimeString(hour, minute, period);
};
